import React from 'react';
import { BaseComponent } from 'components/BaseComponent';
import UserAddressForm from 'components/UserAddressForm';
import { IStepProps } from 'components/Cart/Templates/Mobile/MultiStep';
import { SvgIcon } from 'components/SvgIcon';
import { userService } from 'services/UserService';
import Grid from '@material-ui/core/Grid/Grid';
import Button from '@material-ui/core/Button/Button';
import { FieldValidation } from 'components/Field';
import { cartService } from 'services/CartService';
import { paymentService } from 'services/PaymentService';
import Translate from 'components/Translate';
import { Observable } from 'rxjs/Observable';

const style = require('./multiStep.css');

export interface IProps extends IStepProps { }

export default class AddressAfter extends BaseComponent<any, IProps> {

  finish = async () => {
    if (await this.isFormValid()) {
      userService.setBasicUser()
        .bindComponent(this)
        .subscribe();

      Observable.combineLatest(
        cartService.getCart(),
        paymentService.getPaymentResult()
      )
        .loader()
        .bindComponent(this)
        .subscribe(([cart, paymentResult]) => {
          if (paymentResult.redirectTo) {

            Observable
              .never()
              .loader()
              .subscribe();

            window.location.href = paymentResult.redirectTo;
            return;
          }

          this.props.history.push(`/thankyou/${cart.contentId}/${paymentResult.key}`);
        });
    }
  }

  render() {
    return (
      <div className='step'>
        <FieldValidation.Provider value={this.registerFields}>
          <Grid container spacing={24} className={`${style.component} grid`}>
            <Grid item className='chk-grid__addressAfter' xs={12}>
              <div className='icon'>
                <SvgIcon name='check' />
              </div>
              <div className='chk-paragraph' >
                <h1 className='title theme-label' id='thankyou-title'><Translate term='Obrigado pela Compra!' /></h1>
                <p className='label theme-label'>
                  <Translate term='O seu pagamento está em processamento, complete o breve formulário abaixo para continuar' />
                </p>
              </div>
            </Grid>
            <UserAddressForm />
            <Button
              id='chk-addressafter-button'
              className='chk-btn-download theme-button'
              onClick={this.finish}
            >
              <Translate term='Concluir' />
            </Button>
          </Grid>
        </FieldValidation.Provider>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Mobile/MultiStep/AddressAfter.tsx